import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginComponent from "../../components/Auth/LoginComponent";

const LoginPage = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/xac-thuc-2-yeu-to/xac-thuc-ma-pin.html');
    }

    let redirectUpdateInfo = () => {
        navigate('/cap-nhat-thong-tin.html');
    }

    return <LoginComponent redirect={ () => redirect() } redirectUpdateInfo={() => redirectUpdateInfo() } />

}

export default LoginPage;